import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectSuburbanBathroom = createSelector(selectJsonQuery, jsonQuery => getTermValue('wc_site')(jsonQuery));
